import { Component, Input, ViewChild } from "@angular/core";
import { IAddressValidationModel, IShippingAddressModel } from "@models";
import { SlickDialogComponent } from "@slick-components";
import { AddressValidationDialogComponent } from "@shared-components/address-validation-dialog";

@Component({
	selector: "shipping-address-dialog",
	template: `
<slick-dialog header="Edit Shipping Address" #shippingAddressEditDialogRef>
    <address-search [(shippingAddress)]="shippingAddress"></address-search>
    <slick-dialog-footer>
        <button (click)="saveShippingAddress()" style="width:140px" class="btn btn-outline-success me-2" [slick-button-spinner]="saveSpinnerStatus"><i class="bi bi-check-circle"></i> Save</button>
        <button (click)="cancelShippingAddress()" style="width:140px" class="btn btn-outline-danger"><i class="bi bi-x-circle"></i> Cancel</button>
    </slick-dialog-footer>
</slick-dialog>

<address-validation-dialog #addressValidationDialogRef></address-validation-dialog>`
})

export class ShippingAddressDialogComponent {
	@ViewChild("shippingAddressEditDialogRef") shippingAddressEditDialogRef: SlickDialogComponent;
	@ViewChild("addressValidationDialogRef") addressValidationDialogRef: AddressValidationDialogComponent;
	@Input() isMobile: boolean;
	shippingAddress: IShippingAddressModel;
	saveSpinnerStatus: string;
	res: any;

	constructor() { }

	async openDialog(shippingAddress: IShippingAddressModel): Promise<IShippingAddressModel> {
		return new Promise<IShippingAddressModel>((res) => {
			if (this.isMobile)
				this.shippingAddressEditDialogRef.width = 360;
			this.shippingAddress = shippingAddress;
			this.res = res;

			this.shippingAddressEditDialogRef.showDialog();
		})
	}

	async saveShippingAddress() {
		this.saveSpinnerStatus = "spin";
		const validationResult = await this.addressValidationDialogRef.validate(this.shippingAddress);
		this.saveSpinnerStatus = "reset";

		// The user wants to go back and fix the address
		if (!validationResult.proceed)
			return;

		if (validationResult.useSuggested)
			this.applyValidatedAddress(validationResult.validation);

		this.shippingAddressEditDialogRef.hideDialog();
		this.res(this.shippingAddress);
	}

	cancelShippingAddress() {
		this.shippingAddressEditDialogRef.hideDialog();
		this.res(null);
	}

	private applyValidatedAddress(validation: IAddressValidationModel) {
		this.shippingAddress.address1 = validation.address1;
		this.shippingAddress.address2 = validation.address2 || this.shippingAddress.address2;
		this.shippingAddress.city = validation.city;
		this.shippingAddress.state = validation.state;
		this.shippingAddress.zipcode = validation.zipcode;

		if (validation.latitude && validation.longitude) {
			this.shippingAddress.latitude = validation.latitude;
			this.shippingAddress.longitude = validation.longitude;
		}
	}

}
